/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import { iotDevicesOffblack } from "../assets/iot-devices-offblack";
import {
  type StaticIllustrativeBaseIconProps,
  StaticIllustrativeIcon,
} from "../static-illustrative-icon";

export const IllustrativeIconIotDevicesOffblack = (props: StaticIllustrativeBaseIconProps) => (
  <StaticIllustrativeIcon {...props} svg={iotDevicesOffblack.svg} />
);

IllustrativeIconIotDevicesOffblack.displayName = "IllustrativeIconIotDevicesOffblack";
